module.exports = __webpack_public_path__ + "static/img/Brees-home-bg-sm.ac811d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Brees-home-bg-sm.jpg
// module id = qZmw
// module chunks = 1